<dx-form class="plain-styled-form" [screenByWidth]="getSizeQualifier">
    <dxi-item itemType="group">
        <dxo-col-count-by-screen
            [xs]="1"
            [sm]="2"
            [md]="2"
            [lg]="2"
        ></dxo-col-count-by-screen>
        <dxi-item>
            <dx-select-box
                label="Shift *"
                stylingMode='filled'
                valueExpr="value"
                displayExpr="text"
                [items]="shiftTypeOptions"
                [searchEnabled]="true"
                [showClearButton]="true"
                [(value)]="data.shiftType"
            >
                <dx-validator>
                    <dxi-validation-rule type="required"></dxi-validation-rule>
                </dx-validator>
            </dx-select-box>
        </dxi-item>
        <dxi-item>
            <dx-text-box
                label="Code *"
                [(value)]="data.code"
                stylingMode='filled'
            >
                <dx-validator>
                    <dxi-validation-rule type="required"></dxi-validation-rule>
                </dx-validator>
            </dx-text-box>
        </dxi-item>
        <dxi-item [colSpan]="2">
            <dx-tag-box
                label="Days *"
                [(value)]="data.days"
                [items]="daysOfWeekOptions"
                stylingMode='filled'
                [showClearButton]="true"
                [searchEnabled]="true"
                [showSelectionControls]="true"
                valueExpr="value"
                displayExpr="text"
            >
                <dx-validator>
                    <dxi-validation-rule type="required"></dxi-validation-rule>
                </dx-validator>
            </dx-tag-box>
        </dxi-item>
        <dxi-item>
            <dx-date-box
                label="Start Time *"
                stylingMode='filled'
                [showClearButton]="true"
                [(value)]="data.shiftStart"
                type="time"
                [dateSerializationFormat]="'HH:mm'"
                pickerType="list"
            >
                <dx-validator>
                    <dxi-validation-rule type="required"></dxi-validation-rule>
                </dx-validator>
            </dx-date-box>
        </dxi-item>
        <dxi-item>
            <dx-date-box
                label="End Time *"
                stylingMode='filled'
                [showClearButton]="true"
                [(value)]="data.shiftEnd"
                type="time"
                [dateSerializationFormat]="'HH:mm'"
                pickerType="list"
            >
                <dx-validator>
                    <dxi-validation-rule type="required"></dxi-validation-rule>
                </dx-validator>
            </dx-date-box>
        </dxi-item>
        <dxi-item [colSpan]="2">
            <dx-check-box
                text="Always use assigned shift"
                [(value)]="data.locked"
            ></dx-check-box>
        </dxi-item>
        <dxi-item [colSpan]="1">
            <pictured-item-select-box
                label="Supervisor *"
                [(value)]="data.supervisorId"
                [dataSource]="supervisorDataSource"
            >
            </pictured-item-select-box>
        </dxi-item>
        <dxi-item [colSpan]="1">
            <dx-number-box
                label="Hourly Premium in $"
                [(value)]="data.premiumRate"
                stylingMode='filled'
                [min]="0"
            >
            </dx-number-box>
        </dxi-item>
        <dxi-item [colSpan]="2">
            <dx-check-box
                text="Meal ticket issued after 2 hours of overtime"
                [(value)]="data.hasMealTicked"
            ></dx-check-box>
        </dxi-item>
        <dxi-item [colSpan]="2">
            <dx-tag-box
                label="Select roles that receive a meal ticket"
                [(value)]="data.mealTickedRoles"
                [dataSource]="rolesDataSource"
                displayExpr="name"
                valueExpr="id"
                [showClearButton]="true"
                [searchEnabled]="true"
                stylingMode="filled"
            ></dx-tag-box>
        </dxi-item>
        <dxi-item [colSpan]="2">
            <dx-check-box
                text="Huddle is tracked by supervisor"
                [(value)]="data.showInHuddle"
            ></dx-check-box>
        </dxi-item>
    </dxi-item>
</dx-form>
